const AboutView = () => import(/* webpackChunkName: "AboutView" */ "./AboutView.vue");

export default {
  name: "清软概况",
  path: "/AboutView",
  component: AboutView,
  meta: {
    show:true,
  },
};
